import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCamera = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.5 12.625C9.5 13.1995 9.61316 13.7684 9.83303 14.2992C10.0529 14.83 10.3752 15.3123 10.7814 15.7186C11.1877 16.1248 11.67 16.4471 12.2008 16.667C12.7316 16.8868 13.3005 17 13.875 17C14.4495 17 15.0184 16.8868 15.5492 16.667C16.08 16.4471 16.5623 16.1248 16.9686 15.7186C17.3748 15.3123 17.6971 14.83 17.917 14.2992C18.1368 13.7684 18.25 13.1995 18.25 12.625C18.25 12.0505 18.1368 11.4816 17.917 10.9508C17.6971 10.42 17.3748 9.93766 16.9686 9.53141C16.5623 9.12515 16.08 8.80289 15.5492 8.58303C15.0184 8.36316 14.4495 8.25 13.875 8.25C13.3005 8.25 12.7316 8.36316 12.2008 8.58303C11.67 8.80289 11.1877 9.12515 10.7814 9.53141C10.3752 9.93766 10.0529 10.42 9.83303 10.9508C9.61316 11.4816 9.5 12.0505 9.5 12.625V12.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 7L17.3458 5.19083C17.242 4.98318 17.0823 4.80856 16.8848 4.68654C16.6873 4.56453 16.4597 4.49993 16.2275 4.5H11.5225C11.2903 4.49993 11.0627 4.56453 10.8652 4.68654C10.6677 4.80856 10.508 4.98318 10.4042 5.19083L9.5 7H3.875C3.54348 7 3.22554 7.1317 2.99112 7.36612C2.7567 7.60054 2.625 7.91848 2.625 8.25V18.25C2.625 18.5815 2.7567 18.8995 2.99112 19.1339C3.22554 19.3683 3.54348 19.5 3.875 19.5H20.125C20.4565 19.5 20.7745 19.3683 21.0089 19.1339C21.2433 18.8995 21.375 18.5815 21.375 18.25V8.25C21.375 7.91848 21.2433 7.60054 21.0089 7.36612C20.7745 7.1317 20.4565 7 20.125 7H18.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.4375 9.5C5.49931 9.5 5.55973 9.51833 5.61112 9.55267C5.66251 9.587 5.70256 9.63581 5.72621 9.69291C5.74986 9.75001 5.75605 9.81285 5.744 9.87347C5.73194 9.93409 5.70217 9.98977 5.65847 10.0335C5.61477 10.0772 5.55908 10.1069 5.49847 10.119C5.43785 10.1311 5.37501 10.1249 5.31791 10.1012C5.26081 10.0776 5.212 10.0375 5.17767 9.98612C5.14333 9.93473 5.125 9.87431 5.125 9.8125C5.125 9.72962 5.15792 9.65013 5.21653 9.59153C5.27513 9.53292 5.35462 9.5 5.4375 9.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.375 7V5.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCamera.displayName = 'SvgCamera';
export default SvgCamera;
